import { api } from "../common/utils"
import { PRICING_PROFILE_ENDPOINT } from "../common/constants"
import {
  CreatePricingProfilePayload,
  UpdatePricingProfilePayload
} from "../types"

const profile = {
  getByBrand: async (brandId: string) => {
    const { data } = await api.get(PRICING_PROFILE_ENDPOINT, {
      params: { brand_id: brandId }
    })
    return data
  },
  getById: async (id: string) => {
    const { data } = await api.get(PRICING_PROFILE_ENDPOINT, {
      params: { id }
    })
    return data
  },
  create: async (payload: CreatePricingProfilePayload) => {
    const { data } = await api.post(PRICING_PROFILE_ENDPOINT, payload)
    return data
  },
  update: async (payload: UpdatePricingProfilePayload) => {
    const { data } = await api.post(PRICING_PROFILE_ENDPOINT, payload)
    return data
  },
  delete: async (id: string) => {
    const { data } = await api.delete(`${PRICING_PROFILE_ENDPOINT}?id=${id}`)
    return data
  }
}

export default profile
